export enum TimeUnit {
  Now = 'Just now',
  Minutes = 'm',
  Hours = 'h',
  Days = 'd',
  Weeks = 'w',
  Months = 'mo',
  Years = 'y',
  Error = 'error',
}

export default {
  TimeUnit,
};
